{
  "box.1.label": "Expéditeur (nom, adresse, pays)",
  "box.2.label": "Destinataire (nom, adresse, pays)",
  "box.3.label": "Lieu prévu pour la livraison de la marchandise (lieu, pays)",
  "box.4.label": "Lieu et date de la prise en charge de la marchandise (lieu, pays, date)",
  "box.5.label": "Documents annexés",
  "box.6.label": "Marques et numéros",
  "box.7.label": "Nombre des colis",
  "box.8.label": "Mode d'emballage",
  "box.9.label": "Nature de la marchandise",
  "box.10.label": "Numéro statistique",
  "box.11.label": "Poids brut en kg",
  "box.12.label": "Cubage en m3",
  "box.13.label": "Instructions de l'expéditeur",
  "box.14.label": "Prescriptions d'affranchissement",
  "box.15.label": "Remboursement",
  "box.16.label": "Transporteur (nom, adresse, pays)",
  "box.17.label": "Transporteurs successifs (nom, adresse, pays)",
  "box.18.label": "Réserves et observations du transporteur",
  "box.19.label": "Conventions particulières",
  "box.20.label": "À payer par",
  "box.21.label": "Établie à, le",
  "box.22.label": "Signature et timbre de l'expéditeur",
  "box.23.label": "Signature et timbre du transporteur",
  "box.24.label": "Réception des marchandises (lieu, date, signature et timbre du destinataire)",
  "box.18.continued": "Tout ne tient pas dans cette case. La liste complète des {total, plural, one {# réserve} other {# réserves}} figure dans l'annexe à la page {page}.",
  "annex.box18": "Annexe case 18 — réserves et observations du transporteur",
  "document.title": "Lettre de voiture internationale",
  "document.convention_note": "Ce transport est soumis, nonobstant toute clause contraire, à la Convention CMR.",
  "document.ecmr_number": "Numéro de lettre de voiture",
  "document.reference": "Référence",
  "document.version": "Version {version}",
  "document.continuation": "Suite",
  "document.page_of": "Page {page} sur {pages}",
  "document.inspection_code": "Code d'inspection",
  "document.efti_certification": "Plateforme eFTI : non certifiée (test)",
  "label.vat_number": "Numéro de TVA",
  "label.vehicle": "Véhicule",
  "label.trailer": "Remorque",
  "label.driver": "Conducteur",
  "label.window": "Créneau horaire",
  "label.dangerous_goods": "Marchandises dangereuses (ADR)",
  "label.adr_class": "Classe",
  "label.adr_packing_group": "Groupe d'emballage",
  "label.adr_tunnel_code": "Code tunnel",
  "label.adr_limited_quantity": "Quantité limitée",
  "label.adr_environmentally_hazardous": "Dangereux pour l'environnement",
  "label.carriage_charges": "Prix du transport",
  "label.total": "Total",
  "value.payer.consignor": "Expéditeur",
  "value.payer.consignee": "Destinataire",
  "value.payer.principal": "Donneur d'ordre",
  "value.carriage_paid": "Franco de port",
  "value.carriage_forward": "Port dû",
  "value.package.pallet": "Palette",
  "value.package.box": "Boîte",
  "value.package.carton": "Carton",
  "value.package.crate": "Caisse",
  "value.package.bag": "Sac",
  "value.package.drum": "Fût",
  "value.package.roll": "Rouleau",
  "value.package.bundle": "Botte",
  "value.package.container": "Conteneur",
  "value.package.loose": "En vrac",
  "value.package.other": "Autre",
  "signature.signed_electronically": "Signé électroniquement via Cargofollow",
  "signature.pending": "Pas encore signé",
  "signature.method.drawn": "Signé à l'écran",
  "signature.method.click_otp": "Confirmé par code à usage unique",
  "signature.method.api": "Signé via l'API",
  "signature.method.photo_of_paper": "Photo d'une signature sur papier",
  "signature.trust.platform_auth": "Authentification de la plateforme",
  "signature.trust.ades": "Signature avancée (AdES)",
  "signature.trust.qes": "Signature qualifiée (QES)",
  "signature.seal": "Cachet d'une personne morale",
  "label.signed_at": "Signé le",
  "label.method": "Méthode",
  "label.trust_level": "Niveau de confiance",
  "label.document_hash": "Empreinte du document",
  "label.location": "Localisation",
  "label.accuracy": "Précision",
  "pod.title": "Proof of delivery",
  "pod.intro": "Preuve de livraison relative à la lettre de voiture ci-dessus.",
  "pod.delivered_at": "Livré le",
  "pod.consignee_signature": "Signature du destinataire",
  "pod.colli": "Contrôle des colis",
  "pod.colli_expected": "Nombre de colis sur la lettre de voiture",
  "pod.remarks": "Réserves et observations",
  "pod.no_remarks": "Livré sans réserve.",
  "pod.remarks_on_form": "Tout ne tient pas ici. La liste complète figure dans la case 18 de la lettre de voiture, à la page 1.",
  "pod.photos": "Photos",
  "pod.photos_omitted": "{count} photo(s) non reproduite(s) afin de limiter la taille du document.",
  "pod.remark.phase.pickup": "À la prise en charge",
  "pod.remark.phase.delivery": "À la livraison",
  "pod.remark.type.damage": "Dommage",
  "pod.remark.type.shortage": "Manquant",
  "pod.remark.type.delay": "Retard",
  "pod.remark.type.other": "Autre"
}
